export const PACKAGE_BOUGHT = 'bought'
export const PACKAGE_PROCESSED = 'processed'
export const PACKAGE_IN_TRANSIT = 'in_transit'
export const PACKAGE_ON_DELIVERY = 'on_delivery'
export const PACKAGE_RECEIVED = 'received'
export const PACKAGE_STORED = 'stored'
export const PACKAGE_DELIVERED = 'delivered'
export const PACKAGE_PARTIAL_DELIVERY = 'partial_delivery'

export const PACKAGE_STATUSES = {
  [PACKAGE_BOUGHT]: 0,
  [PACKAGE_PROCESSED]: 1,
  [PACKAGE_IN_TRANSIT]: 2,
  [PACKAGE_ON_DELIVERY]: 3,
  [PACKAGE_PARTIAL_DELIVERY]: 4,
  [PACKAGE_RECEIVED]: 5,
  [PACKAGE_STORED]: 5,
  [PACKAGE_DELIVERED]: 6
}

export const PACKAGE_STATUSES_NAMES = {
  [PACKAGE_BOUGHT]: 'En Preparación',
  [PACKAGE_PROCESSED]: 'Procesado',
  [PACKAGE_IN_TRANSIT]: 'Enviado',
  [PACKAGE_ON_DELIVERY]: 'Despachado',
  [PACKAGE_RECEIVED]: 'Recibido',
  [PACKAGE_STORED]: 'Almacenado',
  [PACKAGE_DELIVERED]: 'Entregado'
}
